import useSearch from './use-search.hook'

export default useSearch
